// The home route ("/") picks its screen by interface version (header buttons ORIG / V1 / V2 / V3, see lib/uiMode.js).
// V4 is the Calm home (status first). ORIG and V3 keep the Dashboard page (ORIG with its old KPI rows); V1 and V2 replace it with their own home screens.
import React from 'react'
import Dashboard from './Dashboard'
import DenseDesk from './DenseDesk'
import ContextDesk from './ContextDesk'
import CalmHome from './CalmHome'
import { useUiMode } from '../lib/uiMode'

export default function Home() {
  const mode = useUiMode()
  if (mode === 'v1') return <DenseDesk />
  if (mode === 'v2') return <ContextDesk />
  if (mode === 'v4') return <CalmHome />
  return <Dashboard />
}
